"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    noun: [
        "driver",
        "protocol",
        "bandwidth",
        "panel",
        "microchip",
        "program",
        "port",
        "card",
        "array",
        "interface",
        "system",
        "sensor",
        "firewall",
        "pixel",
        "alarm",
        "feed",
        "monitor",
        "application",
        "transmitter",
        "bus",
        "circuit",
        "capacitor",
        "matrix"
    ],
    verb: [
        "bypass",
        "hack",
        "override",
        "compress",
        "copy",
        "navigate",
        "index",
        "connect",
        "generate",
        "quantify",
        "calculate",
        "synthesize",
        "input",
        "transmit",
        "program",
        "reboot",
        "parse",
        "handle",
        "circumvent",
        "cross",
        "fumble",
        "tweak",
        "swap"
    ]
};
//# sourceMappingURL=wordLists.js.map